<template>
  <div class="device-detail-openCard-bd">
    <div class="table-bd">
      <custom-table :data="tableList" :index="true" :column="tableColumn" @filter="filterChange" @sort="sortChange" :slots="['action']" max-height="600">
        <template slot="action" slot-scope="scope">
          <el-button size="mini" type="text" @click="onChangeUser(scope.row)">{{ $t('dms_device_detail_openCard.ggsyr') }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <changeUser v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList"></changeUser>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import changeUser from './device_detail_openCard_changeUser.vue';

export default {
  props: {
    deviceInfo: [String, Object, Array],
  },
  components: {
    changeUser,
  },
  data() {
    return {
      tableCode: 'open_card',
      formSearch: {
        search: '',
        deviceId: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
      },

      tableList: [],
      totalRows: 0,

      dialogModel: {},
      dialogVisible: false,
    };
  },
  mounted: function () {
    this.getTableColumn();
    this.getTableList();
  },
  methods: {
    // 获取表格数据列表
    getTableList: function () {
      this.formSearch.deviceId = this.deviceInfo.deviceId;
      this.$getJSON(apis.bootCardDevice, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 更改使用人
    onChangeUser(row) {
      this.dialogModel.title = this.$t('dms_device_detail_openCard.ggsyr');
      // console.log(row);
      this.dialogModel.data = row;
      this.dialogModel.type = 'openCard';
      this.dialogVisible = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.device-detail-openCard-bd {
  padding: 24px;
}
</style>
